import { motion } from 'framer-motion';
import { GALLERY } from '@/lib/site';

const SPAN = {
  tall: 'row-span-2',
  wide: 'col-span-2',
  normal: '',
};

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="eyebrow">Field Diary</p>
            <h2 className="h-display mt-4 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] text-maroon-700 dark:text-foreground">
              Faces, food and
              <br />
              <span className="italic font-serif saffron-text">first smiles.</span>
            </h2>
          </div>
          <p className="max-w-md text-foreground/65">
            Every photograph here is consented, dated and tied to a real program. We never use
            stock pity-imagery to ask for support.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 auto-rows-[160px] sm:auto-rows-[200px] gap-3 md:gap-4">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.6, delay: 0.04 * i }}
              className={`group relative overflow-hidden rounded-3xl bg-muted ${
                SPAN[g.span] || SPAN.normal
              }`}
            >
              <img
                src={g.src}
                alt={g.alt}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-maroon-900/80 via-transparent to-transparent opacity-80" />
              <figcaption className="absolute inset-x-4 bottom-3 text-[12px] font-medium text-white/95 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all">
                {g.alt}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
